export const enum SnSharePermissions {
  View = 'View',
  Edit = 'Edit',
}
